import { render, staticRenderFns } from "./DinamicaFamiliar.vue?vue&type=template&id=588dfc72"
import script from "./DinamicaFamiliar.vue?vue&type=script&lang=js"
export * from "./DinamicaFamiliar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports